import React from 'react';
import { Button } from './ui/Button';
import { MessageCircle } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Regresa a tu Pareja',
    description: 'Un proceso de sanación profunda que permite comprender el origen del distanciamiento, sanar cargas emocionales y restaurar la conexión desde la raíz.',
    idealFor: 'Ideal si sientes que la relación se estancó o se enfrió.',
    icon: '🔹',
    image: 'https://cdn.magicpatterns.com/uploads/1c5iWJsEujSiw3m32mc7Yr/freepik__mi-misma-imagen__1576_(1).jpg'
  }, {
    title: 'Fortalece el Vínculo Amoroso',
    description: 'Técnicas de armonización emocional y energética para desbloquear obstáculos, recuperar la cercanía y renovar el sentimiento mutuo.',
    idealFor: 'Ideal cuando aún hay contacto, pero falta conexión.',
    icon: '🔹',
    image: 'https://cdn.magicpatterns.com/uploads/kUNGGuL65EzC6vPMGzPyvy/StockCake-Pride_Parade_Kiss_1714945033_(1).jpg'
  }, {
    title: 'Atrae a la Persona que Deseas',
    description: 'Trabajos espirituales personalizados enfocados en activar la atracción energética y abrir caminos para que esa persona vuelva a acercarse.',
    idealFor: 'Se realiza con datos básicos y fotografía.',
    icon: '🔹',
    image: 'https://cdn.magicpatterns.com/uploads/gbqvpgFKNtCtedKcjFtHzQ/freepik__the-style-is-candid-image-photography-with-natural__6745.jpg'
  }];
  return <section className="py-24 px-4 bg-white" data-id="element-115">
      <div className="max-w-7xl mx-auto" data-id="element-116">
        <div className="text-center mb-16" data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-118">
            SERVICIOS DISPONIBLES
          </h2>
          <div className="w-24 h-1 bg-rose-500 mx-auto" data-id="element-119" />
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-120">
          {services.map((service, index) => <div key={index} className="flex flex-col bg-rose-50/30 rounded-3xl overflow-hidden border border-rose-100 hover:shadow-xl transition-shadow duration-300" data-id="element-121">
              {/* Service Image */}
              <div className="w-full h-52 overflow-hidden" data-id="element-122">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-123" />
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-124">
                <div className="mb-6" data-id="element-125">
                  <span className="text-4xl mb-4 block" data-id="element-126">{service.icon}</span>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-127">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6" data-id="element-128">
                    {service.description}
                  </p>
                </div>

                <div className="mt-auto space-y-8" data-id="element-129">
                  <div className="bg-white p-4 rounded-xl border border-rose-100 text-sm font-medium text-gray-800" data-id="element-130">
                    👉 {service.idealFor}
                  </div>

                  <a href="https://wa.me/13052196902" target="_blank" rel="noopener noreferrer" className="block" data-id="element-131">
                    <Button className="w-full bg-green-600 hover:bg-green-700 text-white border-none" leftIcon={<MessageCircle className="w-5 h-5" data-id="element-133" />} data-id="element-132">
                      Consultar por WhatsApp
                    </Button>
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}